export const SajuLogEvent = {
  // [홈] 사주 배너 노출
  HOME_SAJU_BANNER_IMPRESSED: {
    amp: 'Home - Saju Banner Impressed',
    ga: 'home_saju_banner_impressed',
  },
  // [홈] 사주 배너 클릭
  HOME_SAJU_BANNER_CLICKED: {
    amp: 'Home - Saju Banner Clicked',
    ga: 'home_saju_banner_clicked',
  },
  // [사주 도화 랜딩] 화면 진입
  SAJU_LANDING_VIEWED: {
    amp: 'Saju Landing - Viewed',
    ga: 'saju_landing_viewed',
  },
  // [사주 도화 랜딩] 시작하기 버튼 클릭
  SAJU_LANDING_DOHWA_START_BUTTON_CLICKED: {
    amp: 'Saju Landing Dohwa - Start Button Clicked',
    ga: 'saju_landing_dohwa_start_button_clicked',
  },
  // [사주 정보 입력] 진입
  SAJU_INPUT_VIEWED: {
    amp: 'Saju Input - Viewed',
    ga: 'saju_input_viewed',
  },
  // [사주 정보 입력] 다음 버튼 클릭
  SAJU_INPUT_NEXT_BUTTON_CLICKED: {
    amp: 'Saju Input - Next Button Clicked',
    ga: 'saju_input_next_button_clicked',
  },
  // [사주 정보 입력] 모르겠어요 버튼 클릭
  SAJU_INPUT_DONT_KNOW_BUTTON_CLICKED: {
    amp: 'Saju Input - Dont Know Button Clicked',
    ga: 'saju_input_dont_know_button_clicked',
  },
  // [사주 결과 로딩] 화면 진입
  SAJU_RESULT_LOADING_VIEWED: {
    amp: 'Saju Result Loading - Viewed',
    ga: 'saju_result_loading_viewed',
  },
  // [사주 결과 모달] 진입
  SAJU_RESULT_VIEWED: {
    amp: 'Saju Result - Viewed',
    ga: 'saju_result_viewed',
  },
  // [사주 결과 모달] 컨텐츠 노출
  SAJU_RESULT_CONTENT_IMPRESSED: {
    amp: 'Saju Result - Content Impressed',
    ga: 'saju_result_content_impressed',
  },
  // [사주 결과 모달] 테스트 결과 클릭
  SAJU_RESULT_TEST_RESULT_CLICKED: {
    amp: 'Saju Result - Test Result Clicked',
    ga: 'saju_result_test_result_clicked',
  },
  // [사주 결과 모달] 투표 버튼 클릭
  SAJU_RESULT_VOTE_BUTTON_CLICKED: {
    amp: 'Saju Result - Vote Button Clicked',
    ga: 'saju_result_vote_button_clicked',
  },
  // [사주 결과 모달] 친구 추가 버튼 클릭
  SAJU_RESULT_ADD_FRIEND_BUTTON_CLICKED: {
    amp: 'Saju Result - Add Friend Button Clicked',
    ga: 'saju_result_add_friend_button_clicked',
  },
  // [사주 결과 모달] 친구 클릭
  SAJU_RESULT_FRIEND_CLICKED: {
    amp: 'Saju Result - Friend Clicked',
    ga: 'saju_result_friend_clicked',
  },
  // [도화살 랜딩] 화면 진입
  DOHWASAL_LANDING_SCREEN_VIEWED: {
    amp: 'Dohwasal Landing - Screen Viewed',
    ga: 'dohwasal_landing_screen_viewed',
  },
  // [도화살 랜딩] 카드 클릭
  DOHWASAL_LANDING_CARD_CLICKED: {
    amp: 'Dohwasal Landing - Card Clicked',
    ga: 'dohwasal_landing_card_clicked',
  },
  // [도화살 랜딩] 인스타 스토리 공유
  DOHWASAL_LANDING_INSTA_STORY_SHARED: {
    amp: 'Dohwasal Landing - Insta Story Shared',
    ga: 'dohwasal_landing_insta_story_shared',
  },
  // [도화살 랜딩] 공유 버튼 클릭
  DOHWASAL_LANDING_SHARE_BUTTON_CLICKED: {
    amp: 'Dohwasal Landing - Share Button Clicked',
    ga: 'dohwasal_landing_share_button_clicked',
  },
  // [도화살 랜딩] 이미지 저장
  DOHWASAL_LANDING_IMAGE_SAVED: {
    amp: 'Dohwasal Landing - Image Saved',
    ga: 'dohwasal_landing_image_saved',
  },
  // [도화살 랜딩] 다른 특징 카드 클릭
  DOHWASAL_LANDING_OTHER_FEATURE_CARD_CLICKED: {
    amp: 'Dohwasal Landing - Other Feature Card Clicked',
    ga: 'dohwasal_landing_other_feature_card_clicked',
  },
  // [도화살 디테일] 화면 진입
  DOHWASAL_DETAIL_SCREEN_VIEWED: {
    amp: 'Dohwasal Detail - Screen Viewed',
    ga: 'dohwasal_detail_screen_viewed',
  },
  // [도화살 디테일] 인스타 스토리 공유
  DOHWASAL_DETAIL_INSTA_STORY_SHARED: {
    amp: 'Dohwasal Detail - Insta Story Shared',
    ga: 'dohwasal_detail_insta_story_shared',
  },
  // [도화살 디테일] 이미지 저장
  DOHWASAL_DETAIL_IMAGE_SAVED: {
    amp: 'Dohwasal Detail - Image Saved',
    ga: 'dohwasal_detail_image_saved',
  },
  // [도화살 디테일] 공유 버튼 클릭
  DOHWASAL_DETAIL_SHARE_BUTTON_CLICKED: {
    amp: 'Dohwasal Detail - Share Button Clicked',
    ga: 'dohwasal_detail_share_button_clicked',
  },

  // [사주 결과 선택] 화면 진입
  SAJU_RESULT_SELECTION_VIEWED: {
    amp: 'Saju Result Selection - Viewed',
    ga: 'saju_result_selection_viewed',
  },
  // [사주 결과 선택] 결과 클릭
  SAJU_RESULT_SELECTION_RESULT_CLICKED: {
    amp: 'Saju Result Selection - Result Clicked',
    ga: 'saju_result_selection_result_clicked',
  },
  // [사주 결과 선택] 새로 진행하기 클릭
  SAJU_RESULT_SELECTION_CREATE_CLICKED: {
    amp: 'Saju Result Selection - Create Clicked',
    ga: 'saju_result_selection_create_clicked',
  },
  // [사주 결과 선택] 앱 설치 클릭
  SAJU_RESULT_SELECTION_APP_INSTALL_CLICKED: {
    amp: 'Saju Result Selection - App Install Clicked',
    ga: 'saju_result_selection_app_install_clicked',
  },

  // [사주 결과]사주 배너 아이템 클릭
  SAJU_RESULT_SAJU_BANNER_ITEM_CLICKED: {
    amp: 'Saju Result - Saju Banner Item Clicked',
    ga: 'saju_result_saju_banner_item_clicked',
  },
  // [사주 일주 분석 랜딩]화면 진입
  DAY_PILLAR_ANALYSIS_LANDING_SCREEN_VIEWED: {
    amp: 'Day Pillar Analysis Landing - Screen Viewed',
    ga: 'day_pillar_Analysis_landing_screen_viewed',
  },
  // [사주 일주 분석 랜딩]버튼 클릭
  DAY_PILLAR_ANALYSIS_LANDING_BUTTON_CLICKED: {
    amp: 'Day Pillar Analysis Landing - Button Clicked',
    ga: 'day_pillar_Analysis_landing_button_clicked',
  },
  // [사주 일주 분석 MBTI 선택]화면 진입
  DAY_PILLAR_ANALYSIS_MBTI_SELECT_SCREEN_VIEWED: {
    amp: 'Day Pillar Analysis Mbti Select - Screen Viewed',
    ga: 'day_pillar_Analysis_mbti_select_screen_viewed',
  },
  // [사주 일주 분석 MBTI 선택]아이템 클릭
  DAY_PILLAR_ANALYSIS_MBTI_SELECT_ITEM_CLICKED: {
    amp: 'Day Pillar Analysis Mbti Select - Item Clicked',
    ga: 'day_pillar_Analysis_mbti_select_item_clicked',
  },
  // [사주 일주 분석 MBTI 선택]만들기 클릭
  DAY_PILLAR_ANALYSIS_MBTI_SELECT_CREATE_CLICKED: {
    amp: 'Day Pillar Analysis Mbti Select - Create Clicked',
    ga: 'day_pillar_Analysis_mbti_select_create_clicked',
  },
  // [사주 일주 분석 로딩]화면 진입
  DAY_PILLAR_ANALYSIS_LOADING_SCREEN_VIEWED: {
    amp: 'Day Pillar Analysis Loading - Screen Viewed',
    ga: 'day_pillar_Analysis_loading_screen_viewed',
  },
  // [사주 일주 분석 로딩]앱 버튼 노출
  DAY_PILLAR_ANALYSIS_LOADING_APP_BUTTON_VIEWED: {
    amp: 'Day Pillar Analysis Loading - App Button Viewed',
    ga: 'day_pillar_Analysis_loading_app_button_viewed',
  },
  // [사주 일주 분석 로딩]앱 버튼 클릭
  DAY_PILLAR_ANALYSIS_LOADING_APP_BUTTON_CLICKED: {
    amp: 'Day Pillar Analysis Loading - App Button Clicked',
    ga: 'day_pillar_Analysis_loading_app_button_clicked',
  },
  // [사주 일주 분석 결과]화면 진입
  DAY_PILLAR_ANALYSIS_RESULT_SCREEN_VIEWED: {
    amp: 'Day Pillar Analysis Result - Screen Viewed',
    ga: 'day_pillar_Analysis_result_screen_viewed',
  },
  // [사주 일주 분석 결과]공유 버튼 클릭
  DAY_PILLAR_ANALYSIS_RESULT_SHARE_BUTTON_CLICKED: {
    amp: 'Day Pillar Analysis Result - Share Button Clicked',
    ga: 'day_pillar_Analysis_result_share_button_clicked',
  },
  // [사주 일주 분석 결과]MBTI 바꾸기 버튼 클릭
  DAY_PILLAR_ANALYSIS_RESULT_UPDATE_MBTI_BUTTON_CLICKED: {
    amp: 'Day Pillar Analysis Result - Update Mbti Button Clicked',
    ga: 'day_pillar_Analysis_result_update_mbti_button_clicked',
  },
}
